// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tw-card[data-v-4c91c5a2]{box-shadow:0 2px 3px #0000001a,0 0 0 1px #0000001a}.tw-card .header[data-v-4c91c5a2]{box-shadow:0 1px 2px #0000001a;margin:-1px -1px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
